<template>
    <div class="px-5 py-5">
        <!-- filter -->
        <div class="filter-list row">
            <div class="col-lg-2">
                <label for="" style="display: block;">Hình thức gia sư</label>
                <el-select v-model="filter.tutorType" placeholder="Hình thức gia sư" class="w-100" clearable>
                    <el-option v-for="item in tutorTypes" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="col-lg-2">
                <label for="" style="display: block;">Thời lượng dạy</label>
                <el-select v-model="filter.duration" placeholder="Thời gian" class="w-100" clearable>
                    <el-option v-for="item in durations" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="col-lg-3">
                <label style="display: block;">Thời gian</label>
                <el-date-picker v-model="filter.dateRange" type="daterange" range-separator="đến"
                    start-placeholder="Từ ngày" end-placeholder="Đến ngày" align="right" unlink-panels clearable
                    size="medium" format="dd/MM/yyyy" value-format="yyyy-MM-dd" />
            </div>
        </div>
        <!-- table -->
        <div class="table-responsive mt-5" style="max-height: 900px">
            <table class="table table-bordered table-hover text-nowrap">
                <thead class="thead-light ">
                    <tr>
                        <th>Chỉ số</th>
                        <th>Tổng</th>
                        <th>Sáng</th>
                        <th>Chiều</th>
                        <th>Tối</th>
                    </tr>
                </thead>
                <tbody v-if="tableLoading">
                    <tr>
                        <td colspan="8" style="text-align: center"><i class="el-icon-loading"></i></td>
                    </tr>
                </tbody>
                <tbody v-else-if="reportList.length === 0">
                    <tr>
                        <td colspan="8" style="text-align: center"><span>Không có dữ liệu</span></td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr v-for="(item, index) in flattenData" :key="item.id">
                        <td v-if="item.children && item.children.length > 0"
                            :style="{ paddingLeft: (item.level * 16 + 9.75) + 'px' }"
                            :class="'row-level-' + item.level">
                            <div style="display: flex;justify-content: space-between;">
                                <span>{{ item.label }}</span>
                                <i class="el-icon-caret-right  carret-icon"
                                    :class="item.openCaret ? 'rotate-90' : ''" @click="toggleCaret(item, index)"
                                    style="color: blue;cursor: pointer;" title="Mở rộng"></i>
                            </div>
                        </td>
                        <td v-else :style="{ paddingLeft: (item.level * 16 + 9.75) + 'px' }"
                            :class="'row-level-' + item.level">
                            {{ item.label }}
                        </td>
                        <td>{{ item.total }}</td>
                        <td>{{ item.morning }}</td>
                        <td>{{ item.afternoon }}</td>
                        <td>{{ item.evening }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { GET_REPORT_TUTOR } from '../../../../core/services/store/tutor/tutor.module';
import moment from "moment-timezone";
export default {
    name: "TutorDirectReport",
    data() {
        return {
            filter: {
                tutorType: '',
                duration: '',
                dateRange: [],
            },
            tableLoading: false,
            reportList: [],
            reportModel: [
                {
                    id: "total_registered",
                    label: "Tổng số lượt đăng ký",
                },
                {
                    id: "total_slots_registered",
                    label: "Tổng số slot đăng ký",
                },
                {
                    id: "total_completed",
                    label: "Tổng số ca hoàn thành",
                },
                {
                    id: "total_teaching_hours",
                    label: "Tổng số giờ dạy",
                },
                {
                    id: "total_direct_hours",
                    label: "Tổng số giờ trực",
                },
                {
                    id: "total_cancelled",
                    label: "Tổng số ca huỷ",
                    openCaret: false,
                    children: [
                        {
                            id: "cancelled_on_standard",
                            label: "Số ca huỷ đúng tiêu chuẩn",
                        },
                        {
                            id: "cancelled_off_standard",
                            label: "Số ca huỷ sai tiêu chuẩn",
                        },
                        {
                            id: "cancelled_student_no_show",
                            label: "Số ca huỷ do học viên không vào",
                        }
                    ]
                },
                {
                    id: "booking_rate",
                    label: "Tỉ lệ đặt lịch",
                },
                {
                    id: "completion_rate_by_slot",
                    label: "Tỉ lệ hoàn thành / slot đăng ký (ca)",
                },
                {
                    id: "completion_rate_by_direct_hours",
                    label: "Tỉ lệ hoàn thành / nguồn lực trực (giờ)",
                },
                {
                    id: "total_cancellation_rate",
                    label: "Tỉ lệ huỷ",
                    openCaret: false,
                    children: [
                        {
                            id: "on_standard_cancellation_rate",
                            label: "Tỉ lệ huỷ đúng tiêu chuẩn",
                        },
                        {
                            id: "off_standard_cancellation_rate",
                            label: "Tỉ lệ huỷ sai tiêu chuẩn",
                        },
                        {
                            id: "student_no_show_rate",
                            label: "Tỉ lệ học viên không vào",
                        }
                    ]
                }
            ],
            durations: [{ value: 60, label: "1 giờ" }, { value: 90, label: "1 giờ 30 phút" }, { value: 150, label: "2 giờ 30 phút" }],
            tutorTypes: [
                { value: 1, label: "Gia sư đặc biệt" },
                { value: 2, label: "Gia sư sau khai giảng" },
                { value: 3, label: "Gia sư lớp đệm" },
                { value: 6, label: "Gia sư thi lại" },
                { value: 4, label: "Gia sư chính sách" },
                { value: 5, label: "Gia sư quân sự" }
            ],
        }
    },
    watch: {
        filter: {
            handler(newVal) {
                this.$router.replace({
                    name: "report-for-tutor",
                    query: {
                        ...this.$route.query,
                        tutorType: newVal.tutorType,
                        duration: newVal.duration,
                        dateRange: newVal.dateRange
                    }
                })
                this.getAPIReport()
            },
            deep: true
        }
    },
    methods: {
        flattenReportList(reportList, level = 0) {
            return reportList.reduce((acc, item) => {
                acc.push({
                    ...item,
                    level
                })
                if (item.children && item.openCaret) {
                    acc.push(...this.flattenReportList(item.children, level + 1))
                }
                return acc
            }, [])
        },
        toggleCaret(item) {
            const index = this.reportList.findIndex((i) => i.id === item.id)
            this.reportList[index].openCaret = !this.reportList[index]?.openCaret
        },
        async getAPIReport() {
            try {
                this.tableLoading = true
                const payload = {
                    from_date: this.filter.dateRange[0],
                    to_date: this.filter.dateRange[1],
                    subtype: this.filter.tutorType,
                    duration: this.filter.duration
                }
                const res = await this.$store.dispatch(GET_REPORT_TUTOR, payload)
                const apiData = res.data
                this.reportList = this.reportModel.map((item) => {
                    const reportItem = {
                        ...item,
                        total: apiData?.total[item.id],
                        morning: apiData?.morning[item.id],
                        afternoon: apiData?.afternoon[item.id],
                        evening: apiData?.evening[item.id]
                    }
                    if (reportItem.children && reportItem.children.length > 0) {
                        reportItem.children = reportItem.children.map((child) => {
                            const childReportItem = {
                                ...child,
                                total: apiData?.total[child.id],
                                morning: apiData?.morning[child.id],
                                afternoon: apiData?.afternoon[child.id],
                                evening: apiData?.evening[child.id]
                            }
                            return childReportItem
                        })
                    }
                    return reportItem
                })
            } catch (error) {

            } finally {
                this.tableLoading = false
            }
        }
    },
    computed: {
        flattenData() {
            return this.flattenReportList(this.reportList)
        }
    },
    mounted() {
        const query = this.$route.query
        this.filter.tutorType = +query.tutorType || ''
        this.filter.duration = +query.duration || ''
        this.filter.dateRange = query.dateRange || []
        if (this.filter.dateRange.length === 0) {
            this.filter.dateRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')]
        } else {
            this.getAPIReport()
        }
    }
}
</script>
<style scoped>
.carret-icon {
    transition: transform 0.3s ease;
}

.carret-icon.rotate-90 {
    transform: rotate(90deg);
}

.row-level-1::before,
.row-level-2::before,
.row-level-3::before {
    content: "•";
    margin-right: 6px;
    color: #999;
}
</style>
